
import {merge as observableMerge, fromEvent as observableFromEvent,  BehaviorSubject ,  Observable } from 'rxjs';

import {map, debounceTime, distinctUntilChanged} from 'rxjs/operators';
import { SendFeedbackByRoleComponent } from './../sendfeedbackbyrole/sendfeedbackbyrole.component';
import { QuestionService } from './../../shared/questionService';
import { QATicket, SendFeedBack } from './../../shared/qaTicket';
import { LocalStorage } from './../../shared/localstorage.service';
import { QATicketNotification } from './qaticketnotification.model';
import { NotificationsService } from './notifications.service';
import { Logger } from './../../shared/logger.service';
import { Component, ElementRef, ViewChild, OnInit, ChangeDetectorRef } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { MatSnackBar } from  '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';






import { AuthenticationService } from '../../shared/authentication.service';

@Component({
  selector: "app-activenotifications",
  templateUrl: "./activenotifications.component.html",
  styleUrls: ["./activenotifications.component.scss"]
})

export class ActiveNotificationsComponent implements OnInit {
  screen = false;
  isDataAvailable = true;
  displayedColumns = ['GCTicketNumber', 'NotificationCreatedBy', 'Creation', 'links'];
  dataChange: BehaviorSubject<QATicketNotification[]> = new BehaviorSubject<QATicketNotification[]>([]);
  get data(): QATicketNotification[] { return this.dataChange.value; }
  dataSource: QATicketNotificationDataSource | null;
  qaTicket = new QATicket();
  emaillist: string[] = [];
  sendFeedBackObj: SendFeedBack;
  QARole: string;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('filter') filter: ElementRef;

  constructor(
    public dialog: MatDialog,
    public service: NotificationsService,
    public cdRef: ChangeDetectorRef,
    public router: Router,
    public route: ActivatedRoute,
    public snackBar: MatSnackBar,
    public logger: Logger,
    public localStorage: LocalStorage,
    public questionService: QuestionService,
    public authService: AuthenticationService) {
  }
  getActiveNotifications() {
    this.service.getActiveQATicketNotifications().subscribe(results => {
      this.screen = true;
      this.dataChange.next(results);
      this.isDataAvailable = true;
      this.cdRef.detectChanges();
      this.initSource();
      this.screen = false;
    });
  }

  ngOnInit() {
    this.screen = true;
    this.getActiveNotifications();
    this.screen = false;
  }

  initSource() {
    this.dataSource = new QATicketNotificationDataSource(this, this.paginator, this.sort);
    observableFromEvent(this.filter.nativeElement, 'keyup').pipe(
      debounceTime(150),
      distinctUntilChanged(),)
      .subscribe(() => {
        if (!this.dataSource) { return; }
        this.dataSource.filter = this.filter.nativeElement.value;
      });
    this.cdRef.detectChanges();
  }

  onGCTicketNumberClick(row: QATicketNotification){
    //hardcoded for now
    window.open('http://qa.texas811.org/viewticket/'+row.GCTicketNumber, 'qualityapp', "", true);
  }

  notificationClick(row: QATicketNotification) {
    this.QARole = this.authService.role;
    this.screen = true;
    this.emaillist = row.SentTo.split(',');

    let dialogRef = this.dialog.open(SendFeedbackByRoleComponent, {
      width: '700px',
      data: {
        feedbackemaillist: row.SentTo,
        gcTicketNumber: row.GCTicketNumber
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'cancel') {
        this.getActiveNotifications();
        return;
      }
      if (result === 'nosave') {
    this.emaillist = row.SentTo.split(',');
    this.service.saveNotification('nosave', row.TicketID, row.SentTo, this.QARole).then(results => {
          this.getActiveNotifications();
        });
        return;
      }
      if (result.SendFeedBackText !== null || result.SendFeedBackText === "") {
        if (result.SendFeedBackTo.length > 0) {
    this.emaillist = row.SentTo.split(',');
    this.service.saveNotification('save', row.TicketID, row.SentTo, this.QARole).then(results => {
            this.getActiveNotifications();
          });
        }
        return;
      }
    });
  }
}

export class QATicketNotificationDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  get filter(): string { return this._filterChange.value; }
  set filter(filter: string) { this._filterChange.next(filter); }

  dataChange: BehaviorSubject<QATicketNotification[]> = new BehaviorSubject<QATicketNotification[]>([]);
  get data(): QATicketNotification[] { return this.dataChange.value; }

  filteredData: QATicketNotification[] = [];
  renderedData: QATicketNotification[] = [];

  constructor(private component: ActiveNotificationsComponent,
    private _paginator: MatPaginator,
    private _sort: MatSort) {
    super();
    super();
    this._filterChange.subscribe(() => this._paginator.pageIndex = 0);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<QATicketNotification[]> {
    // Listen for any changes in the base data, sorting, filtering, or pagination
    const displayDataChanges = [
      this.component.dataChange,
      this._sort.sortChange,
      this._filterChange,
      this._paginator.page,
    ];

    return observableMerge(...displayDataChanges).pipe(map(() => {
      this.filteredData = this.component.data.slice().filter((item: QATicketNotification) => {
        const searchStr = (item.CreatedBy).toLowerCase();
        return searchStr.indexOf(this.filter.toLowerCase()) !== -1;
      });
      // Sort filtered data
      const sortedData = this.sortData(this.filteredData.slice());

      // Grab the page's slice of the filtered sorted data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      this.renderedData = sortedData.splice(startIndex, this._paginator.pageSize);
      return this.renderedData;
    }));
  }

  disconnect() { }

  /** Returns a sorted copy of the database data. */
  sortData(data: QATicketNotification[]): QATicketNotification[] {
    if (!this._sort.active || this._sort.direction === '') { return data; }

    return data.sort((a, b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';

      switch (this._sort.active) {
        case 'QATicketId': [propertyA, propertyB] = [a.TicketID, b.TicketID]; break;
        case 'NotificationSttaus': [propertyA, propertyB] = [a.Status, b.Status]; break;
      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }
}